import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
const styles = require('./index.less');

const Wallpaper = ({ store, src, thumb, index }) => {
  store.use();

  return (
    <div className={styles.photo} onClick={() => store.viewPhotoDetail(src)}>
      <img src={thumb} alt={index} />
    </div>
  );
};

export default wrapStore(Wallpaper, Store);
